import React, { useState, useEffect } from 'react';
import { Button } from '@mui/material';
import DateFilter from '../components/Menu/DateFilter.jsx';
import CircularProgress from '@mui/material/CircularProgress';
import OrdersTable from '../components/OrdersAnalytics/OrdersTable.jsx';
import PullShopifyOrdersDialog from '../features/inventory/PullShopifyOrdersDialog.jsx';
import PageHeader from '../components/layout/PageHeader.jsx';

export default function OrdersLog({ reload }) {
    const dateOptions = { month: '2-digit', day: '2-digit', year: 'numeric' }
    const [load, setLoad] = useState(true)
    const [startDate, setStartDate] = useState(null)
    const [endDate, setEndDate] = useState(null)
    const [pullOpen, setPullOpen] = useState(false)
    const [tableKey, setTableKey] = useState(0)

    useEffect(() => {
        if (startDate === null && endDate === null) {
            initializeDates()
        }
        setLoad(false)
    }, [startDate, endDate])

    const initializeDates = () => {
        let todayDate = new Date()
        const lastWeekDate = new Date(todayDate);
        lastWeekDate.setDate(todayDate.getDate() - 1);
        todayDate = todayDate.toLocaleDateString('en-US', dateOptions)
        const dateOne = lastWeekDate.toLocaleDateString('en-US', dateOptions)
        setStartDate(dateOne)
        setEndDate(todayDate)
    }

    const dateClicked = async (start, end) => {
        setStartDate(start)
        setEndDate(end)
    }

    if (load) {
        return (<div className="container"><CircularProgress /></div>)
    }

    return (
        <div>
            <PageHeader
                title="Orders log"
                subtitle="Sales history and Shopify order pulls"
                actions={
                    <>
                        <Button variant="contained" onClick={() => setPullOpen(true)}>
                            Pull Shopify
                        </Button>
                        <DateFilter ingredient='null' dates={dateClicked} style="dashboard" defaultDays={1} />
                    </>
                }
            />

            <div style={{ padding: '12px 16px 24px' }}>
                <OrdersTable key={tableKey} startDate={startDate} endDate={endDate} reload={reload} />
            </div>

            <PullShopifyOrdersDialog
                open={pullOpen}
                onClose={() => setPullOpen(false)}
                onSuccess={() => setTableKey((k) => k + 1)}
            />
        </div>
    );
};
